import gsap from "gsap";
import { doc } from "prettier";
export const loadAnimation = () => {
  const loading = () => {
    gsap.timeline().add(function () {
      document.querySelector("#loading").style.clipPath = "inset(0 0 0 100%)";
    });
  };

  window.addEventListener("load", () => {
    if (document.querySelector(".js-midloading") != undefined) {
      loading();
    }
  });
};
